export default function Authentication() {
  return (
    <div>Coming soon...</div>
  );
}
